







































import {
  TcAccordion, TcAccordionItem
} from '@telia/shared-ui-components'
import { defineComponent, PropType } from '@vue/composition-api'
import { CfAnslPageLanding } from '@/types/ansl-space/types/cf-ansl-page-landing'
import RichTextContainer from '@/components/rich-text-container/RichTextContainer.vue'

export default defineComponent({
  components: {
    RichTextContainer,
    TcAccordion,
    TcAccordionItem
  },
  props: {
    content: {
      type: Object as PropType<CfAnslPageLanding>,
      required: true
    }
  }
})
